import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from '../../../redux/axios';

const initialState = {
    allProcessData: [],
    processTimeLogs: [],
    signed: [],
    isFetching: false,
    isAllprocessSuccess: false,
    isRejectStageSuccess: false,
    isError: false,
    errorMessage: '',
    docPathname: '',
};

export const getViewAllProcess = createAsyncThunk(
    '/DDsAndAds/viewDetailedProcess?processId',
    async (udata, thunkAPI) => {
        try {
            const { auth } = thunkAPI.getState()
            let tokenStr = auth.user.token;
            let response = await axios({
                url: `/api/DDsAndAds/viewDetailedProcess?processId=${udata}`,
                method: 'get',
                headers: {
                    "Authorization": `Bearer ${tokenStr}`
                }
            })

            let data = response.data;
            if (response.status === 200) {
                return data;
            }
            else if (data.code === 200) {
                return data;
            }
            else {
                return thunkAPI.rejectWithValue(data);
            }
        } catch (err) {
            if (!err.response) {
                throw err
            }

            return thunkAPI.rejectWithValue(err.response.data)
        }
    }
);

export const getRejectStage = createAsyncThunk(
    'api/DDsAndAds/rejectProcess',
    async (udata, thunkAPI) => {
        try {
            const { auth } = thunkAPI.getState()
            let tokenStr = auth.user.token;
            const response = await axios.post('/api/DDsAndAds/rejectProcess', udata, { headers: { "Authorization": `Bearer ${tokenStr}` } });

            let data = response.data;

            if (response.status === 200) {
                return data;
            }
            else if (response.status === 201) {
                return data;
            } else {
                return thunkAPI.rejectWithValue(data);
            }
        } catch (err) {
            if (!err.response) {
                throw err
            }

            return thunkAPI.rejectWithValue(err.response.data)
        }
    }
);


export const DDsAndAdsTakeActionNotySlice = createSlice({
    name: 'DDsAndAdsTakeActionNotification',
    initialState,
    reducers: {
        clearStateDDsAndAdsTakeActionNoty: (state, { payload }) => {
            state.allProcessData = [];
            state.processTimeLogs = [];
            state.signed = [];
            state.isFetching = false;
            state.isAllprocessSuccess = false;
            state.isRejectStageSuccess = false;
            state.isError = false;
            state.errorMessage = '';
            state.docPathname = '';
        },
        DDsAndAdsClearStateRejectStage: (state, { payload }) => {
            state.isRejectStageSuccess = false;
            state.isError = false;
            state.errorMessage = '';
            state.isFetching = false;
        },
    },

    extraReducers: {
        [getViewAllProcess.fulfilled]: (state, { payload }) => {
            state.allProcessData = payload.data.data;
            state.processTimeLogs = payload.data.data.processTimeLogs;
            state.signed = payload.data.data.signed;
            state.docPathname = payload.data.path;
            state.isFetching = false;
            state.isAllprocessSuccess = true;
            return state;
        },
        [getViewAllProcess.pending]: (state) => {
            state.isFetching = true;
        },
        [getViewAllProcess.rejected]: (state, { payload }) => {
            state.isFetching = false;
            state.isError = true;
            if (payload) {
                state.errorMessage = payload.message;
            }
            else {
                state.errorMessage = 'Internal error';
            }
        },
        [getRejectStage.fulfilled]: (state, { payload }) => {

            if (payload.success == false) state.isError = true;
            else state.isError = false;
            if (payload.success) state.isRejectStageSuccess = true;
            if (payload.message) state.errorMessage = payload.message;
            else state.errorMessage = '';
            return state;
        },
        [getRejectStage.pending]: (state) => {
            state.isFetching = true;
        },
        [getRejectStage.rejected]: (state, { payload }) => {
            state.isFetching = false;
            state.isError = true;
            if (payload) {
                state.errorMessage = payload.message;
            }
            else {
                state.errorMessage = 'Internal error';
            }
        }
    },
});

export const { clearStateDDsAndAdsTakeActionNoty, DDsAndAdsClearStateRejectStage } = DDsAndAdsTakeActionNotySlice.actions;

export function clearState() {

    return async (dispatch) => {
        dispatch(clearStateDDsAndAdsTakeActionNoty());
    }
}

export function clearStateRejectStage() {

    return async (dispatch) => {
        dispatch(DDsAndAdsClearStateRejectStage());
    }
}

export const takeActionAsyn = (pdata) => async (dispatch, getState) => {
    try {
        const { auth } = getState()
        let tokenStr = auth.user.token;
        let response = await axios({
            url: `/api/DDsAndAds/document/detailed?processId=${pdata}`,
            method: 'get',
            //timeout: 8000,
            headers: {
                //'Content-Type': 'application/json',
                "Authorization": `Bearer ${tokenStr}`
            }
        })

        let data = response.data;
        return data;
        // console.log(data.data)
        //dispatch(getAllUserDepartments(data));
    } catch (error) {
        return error.response.data;
    }
};

export const DDsAndAdsTakeActionNotySelector = (state) => state.DDsAndAdsTakeActionNotification;

export default DDsAndAdsTakeActionNotySlice.reducer;
